import React from 'react';
import Header from '../components/Husk-n-spices/Header';
import ListItem from '../components/ListItem';
import { data } from '../HusknSpicesData/ProductFeedGradeVegetableAndGrainPowder';
import Footer from '../components/Husk-n-spices/Footer';

export default function DehydratedFruitsPowder() {
  return (
    <div id="wrapperParallax" className="wrapper wrapper-boxed clearfix">
      <Header />
      {data
        .filter(i => i.type === 'DehydratedFruitsPowder')
        .map(dehydratedfruitspowder => {
          return (
            <ListItem
              name={dehydratedfruitspowder.name || 'No Name'}
              description={dehydratedfruitspowder.description || 'No Description'}
              ingredientValues={dehydratedfruitspowder.ingredientValues || 'No Ingredient Values'}
              image={dehydratedfruitspowder.image}
              id={dehydratedfruitspowder.id}
            />
          );
        })}
      <Footer />
    </div>
  );
}
